/**
 * Lovpligtige virksomhedsoplysninger (navn, adresse, CVR, telefon, e-mail)
 * hentet fra DriveGo-kataloget (catalog.tenant).
 */
const LegalFooterInfo = ({ tenant, className = "" }) => {
  if (!tenant) return null;
  const parts = [
    tenant.name,
    tenant.address,
    tenant.cvr ? `CVR ${tenant.cvr}` : null,
    tenant.phone ? `Tlf. ${tenant.phone}` : null,
    tenant.email,
  ].filter(Boolean);
  if (parts.length === 0) return null;
  return (
    <p className={`text-[#52525B] text-xs ${className}`} data-testid="legal-footer-info">
      {parts.join(" · ")}
    </p>
  );
};

export default LegalFooterInfo;
